'use client';
import { rem } from '@s7/styles';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function horizontalSide(placement, arrowY, arrowOffset, arrowPosition) {
    if (placement === 'center' || arrowPosition === 'center') {
        return {
            top: arrowY
        };
    }
    if (placement === 'end') {
        return {
            bottom: arrowOffset
        };
    }
    if (placement === 'start') {
        return {
            top: arrowOffset
        };
    }
    return {};
}
function verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir) {
    if (placement === 'center' || arrowPosition === 'center') {
        return {
            left: arrowX
        };
    }
    if (placement === 'end') {
        return {
            [dir === 'ltr' ? 'right' : 'left']: arrowOffset
        };
    }
    if (placement === 'start') {
        return {
            [dir === 'ltr' ? 'left' : 'right']: arrowOffset
        };
    }
    return {};
}
const radiusLookup = {
    bottom: 'borderTopLeftRadius',
    left: 'borderTopRightRadius',
    right: 'borderBottomLeftRadius',
    top: 'borderBottomRightRadius'
};
function getArrowPositionStyles({ position, arrowSize, arrowOffset, arrowRadius, arrowPosition, arrowX, arrowY, dir }) {
    const [side, placement = 'center'] = position.split('-');
    const baseStyles = {
        width: rem(arrowSize),
        height: rem(arrowSize),
        transform: 'rotate(45deg)',
        position: 'absolute',
        [radiusLookup[side]]: rem(arrowRadius)
    };
    const arrowPlacement = rem(-(arrowSize / 2));
    if (side === 'left') {
        return _extends({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition), {
            right: arrowPlacement,
            borderLeftColor: 'transparent',
            borderBottomColor: 'transparent'
        });
    }
    if (side === 'right') {
        return _extends({}, baseStyles, horizontalSide(placement, arrowY, arrowOffset, arrowPosition), {
            left: arrowPlacement,
            borderRightColor: 'transparent',
            borderTopColor: 'transparent'
        });
    }
    if (side === 'top') {
        return _extends({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir), {
            bottom: arrowPlacement,
            borderTopColor: 'transparent',
            borderLeftColor: 'transparent'
        });
    }
    if (side === 'bottom') {
        return _extends({}, baseStyles, verticalSide(placement, arrowX, arrowOffset, arrowPosition, dir), {
            top: arrowPlacement,
            borderBottomColor: 'transparent',
            borderRightColor: 'transparent'
        });
    }
    return {};
}

export { getArrowPositionStyles };
//# sourceMappingURL=getArrowPositionStyles.js.map
